<lib-dba-mat-dialog-title (cancelClick)="dialogRef.close()">
  {{Title}}
</lib-dba-mat-dialog-title>

<mat-dialog-content [formGroup]="FormGroup">
  @if(loading){<lib-spinner-dialog></lib-spinner-dialog>}

  <lib-select-create formControlName="debitorControl" [selectList]="debitorList" selectValue="DebitorID"
    [selectNameList]="['Nummer','Name','PLZ','Ort','LandName']" [label]="language.debitor | translationPipe"
    [showDeselect]="false" [showCreate]="false">
  </lib-select-create>

  <lib-select-create formControlName="standortControl" [selectList]="getfilterStandortList()" selectValue="StandortID"
    [selectNameList]="['Bezeichnung']"  [showCreate]="permissionService.StandortSchreiben && FormGroup.controls['debitorControl'].value != null" 
    [createCallbackFunction]="OpenCreateStandortDialog"  [label]="language.Standort | translationPipe"
    [showDeselect]="true"  [(value)]="selectedstandortModelView" [required]="true">
  </lib-select-create>
  
  <lib-select-create formControlName="objektControl" [selectList]="objektList" style="width: 100%;" 
    selectValue="ObjektID" [selectNameList]="['DebitorNummer','DebitorName','Bezeichnung','PLZ','Ort','LandName']"
    [styleList]="styleList" [label]="language.objekt | translationPipe" [showDeselect]="false" [showCreate]="false"
    [required]="true">
  </lib-select-create>

  <mat-form-field>
    <mat-label>{{language.Bezeichnung | translationPipe}}</mat-label>
    <input matInput maxlength="100" required formControlName="bezeichnungControl">
  </mat-form-field>

  <!--div class="row">
    <mat-form-field>
      <mat-label>{{language.Longitude | translationPipe}}</mat-label>
      <input matInput required formControlName="longitudeControl" (blur)="formatLongitude()">
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{language.Latitude | translationPipe}}</mat-label>
      <input matInput required formControlName="latitudeControl" (blur)="formatLatitude()">
      @if(this.LatitudeControl.value != null && this.LongitudeControl.value != null){
      <mat-icon matSuffix (click)="openMaps()">public</mat-icon>
      }
    </mat-form-field>
  </div-->
  
</mat-dialog-content>

<mat-dialog-actions>
  <lib-dba-mat-dialog-footer (cancelClick)="dialogRef.close()" (saveClick)="Save()"></lib-dba-mat-dialog-footer>
</mat-dialog-actions>